import React from 'react'
import { useNavigate } from 'react-router-dom'

const Forget = () => {
  const navigate=useNavigate()
  return (
    <div className="bg-white dark:bg-gray-900">
    <div className="flex justify-center h-screen">
      
      <div className="flex items-center w-full max-w-md px-6 mx-auto lg:w-2/6">
        <div className="flex-1">
          <div className="text-center">
            <h2 className="text-4xl font-bold text-center text-gray-700 dark:text-white">Forgot Password</h2>
            {/* <p className="mt-3 text-gray-500 dark:text-gray-300">Sign in to access your Admin Panel</p> */}
          </div>
          <div className="mt-8">
            <form>
              <div className='mt-6'>
                <label htmlFor="email" className="block mb-2 text-sm text-gray-600 dark:text-gray-200">Email</label>
                <input type="email" name="email" id="email" placeholder="example@example.com" className="block w-full px-4 py-2 mt-2 text-gray-700 placeholder-gray-400 bg-white border border-gray-200 rounded-md dark:placeholder-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-700 focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring focus:ring-opacity-40" />
              </div>
            {/* 
              <div className='mt-6'>
                <label htmlFor="Password" className="block mb-2 text-sm text-gray-600 dark:text-gray-200">Password</label>
                <input type="Password" name="Password" id="Password" placeholder="Password" className="block w-full px-4 py-2 mt-2 text-gray-700 placeholder-gray-400 bg-white border border-gray-200 rounded-md dark:placeholder-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-700 focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring focus:ring-opacity-40" />
              </div> */}

              <div className="mt-6">
                <button className="w-full px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-blue-500 rounded-md hover:bg-blue-400 focus:outline-none focus:bg-blue-400 focus:ring focus:ring-blue-300 focus:ring-opacity-50">
                  Forgot
                </button>
              </div>
            </form>
            <p className="mt-6 text-sm text-center text-gray-400" onClick={()=>navigate('/admin-signup')}>Not Registered Yet? <a href="#" className="text-blue-500 focus:outline-none focus:underline hover:underline">Register now</a>.</p>
          </div>
        </div>
      </div>

      <div className="hidden bg-cover lg:block lg:w-2/3" style={{backgroundImage: 'url(https://thumbs.dreamstime.com/b/desperate-woman-trying-to-log-her-computer-forgot-password-young-96487163.jpg)'}}>
        <div className="flex items-center h-full px-20 bg-gray-900 bg-opacity-40">
          <div>
            <h2 className="text-4xl font-bold text-white">Forgot Password</h2>
            <p className="max-w-xl mt-3 text-gray-300">Nartec Software Company Admin Panel Forgot Password</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  )
}

export default Forget